import DayJSUtils from '@date-io/dayjs';
import { MuiThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Router } from 'react-router-dom';
import 'reflect-metadata';
import AppComponent from './app.component';
import { history } from './app.routes';
import theme from './app.theme';
import ErrorBoundary from './errorboundary.component';
import { AppModuleProvider } from './providers/app-module.provider';
import registerServiceWorker from './register.serviceworker';
import { IntlService } from './services/intl.service';

const registerSW = false;

const localLang = 'en';

const intlService = new IntlService();
ReactDOM.render(
	<MuiPickersUtilsProvider utils={DayJSUtils}>
		<IntlProvider locale={localLang} messages={intlService.GetMessagesIntlProvider(localLang)}>
			<Router history={history}>
				<ErrorBoundary>
					<AppModuleProvider>
						<MuiThemeProvider theme={theme}>
							<AppComponent />
						</MuiThemeProvider>
					</AppModuleProvider>
				</ErrorBoundary>
			</Router>
		</IntlProvider>
	</MuiPickersUtilsProvider>,
	document.getElementById('root') as HTMLElement
);
if (registerSW) {
	registerServiceWorker();
}



// WEBPACK FOOTER //
// ./src/index.tsx